import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { destroyAllSelect2 } from './select2Modal'

/**
 * Обёртка маршрутов: при любом переходе (в т.ч. «Назад») уничтожает Select2,
 * чтобы выпадающие списки, прикреплённые к body, не «залипали» на экране.
 */
export default function Select2NavigationCleanup() {
  const location = useLocation()

  useEffect(() => {
    return () => {
      destroyAllSelect2()
    }
  }, [location.pathname, location.search, location.hash, location.key])

  return <Outlet />
}
